export type ApiUrls = {
  workflow?: string;
  b2b?: string;
  configurations?: string;
  auth: string;
};
export type ApplicationUrls = {
  workflow?: string;
  b2b?: string;
  configurations?: string;
  documentation?: string;
};
export enum Environment {
  PROD = 'prod',
  LOCAL = 'local',
  DEV = 'dev',
  STAGING = 'stage',
}
export enum ServiceType {
  MANAGEMENT = 'management',
  CLOUD = 'cloud',
}
interface INimmstaCommonsModuleConfiguration {
  apiUrls: ApiUrls;
  applicationUrls: ApplicationUrls;
  environment?: Environment;
  serviceType: ServiceType;
  defaultPageSizeOptions: number[];
  defaultPageSize: number;
  USER_KEY: string;
  keycloakUrl: string;
  keycloakRealm: string;
  keycloakClientId: string;
  defaultConfigurationVersion: number;
  androidAppSoftwareId?: string;
  translationFiles?: string[];
  maintenanceInfoSource?: string;
}
export abstract class NimmstaCommonsModuleConfiguration implements INimmstaCommonsModuleConfiguration {
  apiUrls: ApiUrls;

  applicationUrls: ApplicationUrls;

  environment?: Environment;

  serviceType: ServiceType;

  defaultPageSizeOptions: number[];

  defaultPageSize: number;

  USER_KEY: string;

  keycloakUrl: string;

  keycloakRealm: string;

  keycloakClientId: string;

  defaultConfigurationVersion: number;

  androidAppSoftwareId?: string;

  translationFiles?: string[];

  maintenanceInfoSource?: string;

  constructor(config: INimmstaCommonsModuleConfiguration) {
    this.apiUrls = config.apiUrls;
    this.applicationUrls = config.applicationUrls;
    this.environment = config.environment;
    this.serviceType = config.serviceType;
    this.defaultPageSizeOptions = config.defaultPageSizeOptions;
    this.defaultPageSize = config.defaultPageSize;
    this.USER_KEY = config.USER_KEY;
    this.keycloakUrl = config.keycloakUrl;
    this.keycloakRealm = config.keycloakRealm;
    this.keycloakClientId = config.keycloakClientId;
    this.defaultConfigurationVersion = config.defaultConfigurationVersion;
    this.androidAppSoftwareId = config.androidAppSoftwareId;
    this.translationFiles = config.translationFiles;
    this.maintenanceInfoSource = config.maintenanceInfoSource;
  }
}
